import { useUserSelector } from '~/hooks';
import { IAllowedRequest } from '~/models';

const DEFAULT_CONTROLS = {
  locumTenensDentist: false,
  permProduct: false,
  ppJob: false,
  tempOrMdbShifts: false,
} satisfies IAllowedRequest;

export const useRequestControls = () => {
  const currentUser = useUserSelector();

  const controls: IAllowedRequest = currentUser?.allowedRequest || DEFAULT_CONTROLS;

  return {
    isLocumTenensDentistAllowed: controls.locumTenensDentist,
    isPermProductAllowed: controls.permProduct,
    isPermanentPlacementAllowed: controls.ppJob,
    isTempOrMDBShiftAllowed: controls.tempOrMdbShifts,
  };
};
